import React, { Component } from "react";
import gql from "graphql-tag";
import { Query, Mutation } from "react-apollo";
import { Button, Container, Header, Input } from "semantic-ui-react";
import InfiniteScroll from "react-infinite-scroller";

import { TAGS_QUERY } from "../../graphql/queries";
import Tag from "./Tag";
import TagForm from "./TagForm";
import { Loader } from "components/Loader";
import { withLanguage } from 'HOCs'

class TagsList extends Component {
  state = {
    newTagFormVisibility: false,
    hasMore: true,
    offset: 0,
    q: null
  };
  handleSearch = event => this.setState({ q: event.target.value });
  showTagForm = () => {
    this.setState({ newTagFormVisibility: true });
  };
  hideTagForm = () => {
    this.setState({ newTagFormVisibility: false });
  };
  render() {
    return (
      <Container>
        <Header as="h1">Tags</Header>
        <div style={{ marginBottom: "2rem" }}>
          <Input
            placeholder="Search..."
            value={this.state.q}
            onChange={this.handleSearch}
          />
        </div>
        {this.state.newTagFormVisibility ? (
          <Mutation
            mutation={CREATE_TAG}
            update={(cache, { data: { createTag } }) => {
              const { tags } = cache.readQuery({
                query: TAGS_QUERY,
                variables: {
                  language: this.props.language,
                  q: this.state.q,
                  offset: this.state.offset
                }
              });
              cache.writeQuery({
                query: TAGS_QUERY,
                variables: {
                  language: this.props.language,
                  q: this.state.q,
                  offset: this.state.offset
                },
                data: { tags: [createTag, ...tags] }
              });
            }}
          >
            {(createTag, { loading: createLoading, error: createError }) => {
              const addTag = input =>
                createTag({
                  variables: { language: this.props.language, input }
                });
              return (
                <TagForm
                  hide={this.hideTagForm}
                  submit={addTag}
                  loading={createLoading}
                />
              );
            }}
          </Mutation>
        ) : (
          <Button primary onClick={this.showTagForm}>
            Add New Tag
          </Button>
        )}
        <Query
          query={TAGS_QUERY}
          variables={{ language: this.props.language, q: this.state.q }}
          fetchPolicy="network-only"
        >
          {({ data, fetchMore, error }) => {
            if (data && data.tags) {
              return (
                <InfiniteScroll
                  loadMore={() => {
                    fetchMore({
                      variables: { offset: data.tags.length },
                      updateQuery: (prev, { fetchMoreResult, variables }) => {
                        if (!fetchMoreResult) return prev;
                        if (!fetchMoreResult.tags.length) {
                          this.setState({ hasMore: false });
                        }
                        return Object.assign({}, prev, {
                          tags: [...prev.tags, ...fetchMoreResult.tags]
                        });
                      }
                    });
                  }}
                  hasMore={this.state.hasMore}
                  loader={<Loader key="loader-key" />}
                >
                  {data.tags.map(tag => {
                    return (
                      <Mutation
                        mutation={UPDATE_TAG}
                        key={tag.id}
                        update={(cache, { data }) => {
                          const { tags } = cache.readQuery({
                            query: TAGS_QUERY,
                            variables: {
                              language: this.props.language,
                              q: this.state.q,
                              offset: this.state.offset
                            }
                          });
                          cache.writeQuery({
                            query: TAGS_QUERY,
                            variables: {
                              language: this.props.language,
                              q: this.state.q,
                              offset: this.state.offset
                            },
                            data: {
                              tags: tags.map(tag =>
                                tag.id === data.updateTag.id
                                  ? data.updateTag
                                  : tag
                              )
                            }
                          });
                        }}
                      >
                        {(
                          updateTag,
                          { loading: updateLoading, error: updateError }
                        ) => (
                          <Mutation
                            mutation={DELETE_TAG}
                            update={(cache, { data: { deleteTag } }) => {
                              const { tags } = cache.readQuery({
                                query: TAGS_QUERY,
                                variables: {
                                  language: this.props.language,
                                  q: this.state.q,
                                  offset: this.state.offset
                                }
                              });
                              cache.writeQuery({
                                query: TAGS_QUERY,
                                variables: {
                                  language: this.props.language,
                                  q: this.state.q,
                                  offset: this.state.offset
                                },
                                data: {
                                  tags: tags.filter(
                                    tag => tag.id !== deleteTag.id
                                  )
                                }
                              });
                            }}
                          >
                            {(
                              deleteTag,
                              { loading: deleteLoading, error: deleteError }
                            ) => {
                              const edit = name =>
                                updateTag({
                                  variables: {
                                    language: this.props.language,
                                    id: tag.id,
                                    input: { name }
                                  }
                                });
                              const remove = () =>
                                deleteTag({
                                  variables: {
                                    language: this.props.language,
                                    id: tag.id
                                  }
                                });
                              const toggleVisibility = () =>
                                updateTag({
                                  variables: {
                                    oldLanguage: this.props.language,
                                    newLanguage: this.props.language,
                                    id: tag.id,
                                    input: { visible: !tag.visible }
                                  }
                                });
                              return (
                                <Tag
                                  key={tag.id}
                                  name={tag.name}
                                  visible={tag.visible}
                                  edit={edit}
                                  delete={remove}
                                  toggleVisibility={toggleVisibility}
                                  updateLoading={updateLoading}
                                  deleteLoading={deleteLoading}
                                />
                              );
                            }}
                          </Mutation>
                        )}
                      </Mutation>
                    );
                  })}
                </InfiniteScroll>
              );
            }
            return null;
          }}
        </Query>
      </Container>
    );
  }
}

export const CREATE_TAG = gql`
  mutation CreateTag($language: String!, $input: CreateTagInput!) {
    createTag(language: $language, input: $input) {
      id
      name
      visible
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($language: String!, $id: ID!, $input: UpdateTagInput!) {
    updateTag(language: $language, id: $id, input: $input) {
      id
      name
      visible
    }
  }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($language: String!, $id: ID!) {
    deleteTag(language: $language, id: $id) {
      id
    }
  }
`;
export default withLanguage(TagsList);



// WEBPACK FOOTER //
// ./src/pages/Tags/index.js